import React from 'react'
import { IFavoriteItemsList } from './interface'
import { FavoriteItemsTypesView } from './view'

export const FavoriteItemsType: React.FC<IFavoriteItemsList> = ({ item, deleteItem, applyItem, isLastItem }) => {
  return <FavoriteItemsTypesView item={item} applyItem={applyItem} deleteItem={deleteItem} isLastItem={isLastItem} />
}
